import { motion } from 'framer-motion'
import { Award, Calendar, ExternalLink } from 'lucide-react'

const Certificates = () => {
  const certificates = [
    {
      title: 'Ethereum and Solidity: The Complete Developer\'s Guide',
      issuer: 'Udemy',
      date: 'Feb 22, 2024',
      link: 'https://udemy-certificate.s3.amazonaws.com/pdf/UC-97c3cacd-15a0-4ff8-974f-1ebf6ae98aea.pdf',
      description: 'Complete Ethereum and Solidity development course by Stephen Grider - 24 total hours of blockchain development training'
    },
    {
      title: 'React Nanodegree Program Certificate',
      issuer: 'Udacity',
      date: 'April 29, 2022',
      link: 'https://www.udacity.com/certificate/FJYKWLAH',
      description: 'Certificate of completion for React Nanodegree Program, verified by Udacity founder Sebastian Thrun'
    },
    {
      title: 'Meta React Native Specialization',
      issuer: 'Coursera & Meta',
      date: 'October 26, 2023',
      link: 'https://www.coursera.org/account/accomplishments/specialization/certificate/TPES2AV46EGM',
      description: 'Complete React Native specialization including 8 courses: Mobile Development, JavaScript, Version Control, React Basics, React Native, Data Management, UX/UI Design, and Capstone project'
    },
    {
      title: 'Version Control',
      issuer: 'Coursera & Meta',
      date: 'Oct 13, 2023',
      link: 'https://www.coursera.org/account/accomplishments/certificate/7788M5UXW2EP',
      description: 'Version Control course certificate from Meta, covering essential Git and version control practices for software development'
    }
  ]

  return (
    <div className="min-h-screen pt-16">
      {/* Header Section */}
      <section className="section-padding">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6">
              Certificates & Achievements
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Professional certifications and achievements that validate my expertise and continuous learning journey in software development.
            </p>
          </motion.div>

          {/* Certificates Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {certificates.map((cert, index) => (
              <motion.div
                key={cert.title}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                className="card hover:shadow-lg transition-shadow duration-300"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-yellow-100 dark:bg-yellow-900/20 rounded-lg flex items-center justify-center">
                      <Award className="w-6 h-6 text-yellow-600 dark:text-yellow-400" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white" dangerouslySetInnerHTML={{ __html: cert.title }}>
                      </h3>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {cert.issuer}
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 dark:text-gray-400 mb-4">
                  {cert.description}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
                    <Calendar className="w-4 h-4" />
                    <span>{cert.date}</span>
                  </div>
                  <a
                    href={cert.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors duration-200"
                  >
                    <span className="text-sm font-medium">View Certificate</span>
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Certificates 